import React, { useState, useEffect } from "react";
import { getScenarios, getUsers, getEmissionType } from "../../../services/api";
import GainSelect from "../../../components/objects/GainSelect";
import GainButton from "../../../components/objects/GainButton";

export default function Filter(props) {
  const Sector = [
    {
      name: "All sector",
      value: "All sector",
    },
    {
      name: "TRA_RD_M4",
      value: "TRA_RD_M4",
    },
    {
      name: "TRA_RD_LD4C",
      value: "TRA_RD_LD4C",
    },
    {
      name: "TRA_RD_LD4T",
      value: "TRA_RD_LD4T",
    },
    {
      name: "TRA_RD_HDT",
      value: "TRA_RD_HDT",
    },
    {
      name: "TRA_RD_HDB",
      value: "TRA_RD_HDB",
    },
  ];

  const [Users, setUsers] = useState([
    {
      id: 0,
      name: "All Owners",
    },
  ]);

  const [Scenarios, setScenarios] = useState({
    data: [],
    options: [],
  });

  const [Filters, setFilters] = useState({
    scenario: "",
    sector: "All sector",
  });

  useEffect(() => {
    userLists();
    scenarioLists();
  }, []);

  useEffect(() => {
    props.onFilter(Filters);
  }, [Scenarios]);

  const userLists = async () => {
    const res = await getUsers();
    const options = res.data.data.map((item) => ({
      id: item.id,
      name: item.firstname,
    }));
    setUsers([...Users, ...options]);
  };

  const scenarioLists = async (owner) => {
    const res = await getScenarios();
    const options = res.data.map((item) => ({
      id: item.id,
      name: item.scenario_name,
      value: item.file_name,
      owner: item.owner.id,
    }));
    if (owner) {
      const filterOption = Scenarios.data.filter(
        (item) => item.owner === owner
      );
      setScenarios({ ...Scenarios, options: filterOption });
    } else {
      setScenarios({ ...Scenarios, data: options, options: options });
    }
  };

  const Result = () => {
    props.onFilter(Filters);
  };

  return (
    <div className="flex w-full flex-col">
      <div onClick={Result} className="mb-6 self-end">
        <GainButton label="Results" />
      </div>
      <div className="grid grid-cols-5 gap-4 2xl:gap-12 pb-8">
        <GainSelect
          label="Emission Scenario"
          options={Users}
          default={[0]}
          onChange={scenarioLists}
          useId
        />
        <GainSelect
          options={Scenarios.options}
          onChange={(e) => setFilters({ ...Filters, scenario: e })}
        />
        <GainSelect label="Region" disabled />
        <GainSelect disabled />
        <GainSelect
          label="Sector Type"
          options={Sector}
          default={"All sector"}
          onChange={(e) => setFilters({ ...Filters, sector: e })}
        />
      </div>
    </div>
  );
}
